// components/TextTransformSelector.jsx
import React from "react";
import SingleSelectBox from "../../../../components/FormComponents/SingleSelectBox";

const TEXT_TRANSFORM_OPTIONS = [
  { id: "", name: "NONE" },
  { id: "uppercase", name: "UPPERCASE" },
  { id: "lowercase", name: "lowercase" },
  { id: "capitalize", name: "Capitalize" }
];

const TextTransformSelector = ({ value, onChange }) => {
  const handleChange = (selectedOption) => {
    if (selectedOption && typeof selectedOption === "object") {
      onChange(selectedOption.id);
    } else {
      onChange("");
    }
  };
  console.log("value", value);
  return (
    <div>
      <SingleSelectBox
        id="text-transform"
        label={"Text Transformation"}
        placeholder="Choose a text style"
        options={TEXT_TRANSFORM_OPTIONS}
        selectedData={TEXT_TRANSFORM_OPTIONS.find((opt) => opt.id === value)}
        onChange={handleChange}
      />
    </div>
  );
};

export default TextTransformSelector;
